export default __webpack_public_path__ + "static/media/network_error.982535a6.svg";